export default __webpack_public_path__ + "static/media/1821.3c989304.png";